<template>
  <div class="box has-text-centered content is-medium">
      <h2>Recovering account access...</h2>
      <div v-if="loading" class="loading-block my-5">
        <b-loading v-model="loading" :is-full-page="false"></b-loading>
      </div>
      
      <template v-if="confirmed">
      <p>Success. You are now logged in :-)</p>
      <p class="has-text-centered mt-3"><a class="button is-primary" href="/changepassword">Click here to change your password</a></p>
      </template>
      <p
        v-if="errorMsg"
        class="has-text-danger"
      >Sorry, something went wrong while recovering access: {{errorMsg}}</p>
  </div>
</template>

<script>

export default {
  name: "RecoveryForm",
  props: {
    recoveryToken: {
      type: String,
      default: false,
    },
  },
  data: function () {
    return {
      confirmed: false,
      errorMsg: null,
      loading: false,
    };
  },
  mounted: function () {
    this.attemptRecovery();
  },
  methods: {
    attemptRecovery: function () {
      this.confirmedMsg = null;
      this.loading = true;
      var self = this
      if (this.recoveryToken) {
        this.$store
          .dispatch("recover", this.recoveryToken)
          .then((response) => {   
            console.log("recover response", response)         
            self.confirmed =true
            self.loading = false;
            //this.$parent.trackPageView("account_confirmed")
          })
          .catch((error) => {
            self.loading = false
            if (error.responseText.trim() == "ERROR_INVALID_TOKEN") {
              self.errorMsg =
                "Unknown recovery token. Maybe you already recovered your account?";
            } else {
              self.errorMsg =
                "OMG, something went wrong. It was us, not you and the team was already notified. Please try again later.";
            }
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.loading-block {
  position: relative;
  margin: auto;
  width: 90%;
  height: 70px;
}
</style>